import { getCall } from '@services/rest-service';

// Retrieves content by slug from cosmos
export const getContent = (slug: string): Promise<string> => {
  return getCall<string>(`content/${slug}`);
};
